// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-fade-enter[data-v-ce3edfde],
.modal-fade-leave-active[data-v-ce3edfde] {
  opacity: 0;
}
[data-v-ce3edfde] .modal {
  display: flex;
  flex-direction: column;
  width: 100%;
}
[data-v-ce3edfde] .modal .is-clean {
    padding: 0;
}
@media (min-width: 641px) {
[data-v-ce3edfde] .modal {
    min-width: 500px;
}
[data-v-ce3edfde] .modal-sm {
    max-width: 550px;
}
}
@media (min-width: 768px) {
[data-v-ce3edfde] .modal {
    max-width: 600px;
}
[data-v-ce3edfde] .modal-md {
    max-width: 800px;
}
}
@media (min-width: 1024px) {
[data-v-ce3edfde] .modal-lg {
    max-width: 960px;
}
}
@media (min-width: 1280px) {
[data-v-ce3edfde] .modal-xl {
    max-width: 1200px;
}
}
@media (max-height: 599px) {
[data-v-ce3edfde] .modal {
    height: 100%;
}
[data-v-ce3edfde] .modal-height-lg {
    height: 100%;
}
[data-v-ce3edfde] .modal-height-xl {
    height: 100%;
}
}
@media (min-height: 600px) {
[data-v-ce3edfde] .modal {
    max-height: 80vh;
}
[data-v-ce3edfde] .modal-height-lg {
    height: 60vh;
}
[data-v-ce3edfde] .modal-height-xl {
    height: 80vh;
}
}
[data-v-ce3edfde] .modal-fullscreen {
  width: 98%;
  min-width: 98%;
  height: 98%;
  min-height: 98%;
}
.modal-content[data-v-ce3edfde] {
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 0.5rem;
  overflow: auto;
}
.modal-footer[data-v-ce3edfde] {
  padding-left: 2rem;
  padding-right: 2rem;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
